import { render, staticRenderFns } from "./storeCertification.vue?vue&type=template&id=29bbb383&scoped=true&"
import script from "./storeCertification.vue?vue&type=script&lang=js&"
export * from "./storeCertification.vue?vue&type=script&lang=js&"
import style0 from "./storeCertification.vue?vue&type=style&index=0&id=29bbb383&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bbb383",
  null
  
)

export default component.exports